import React from 'react';
import { ArrowDown, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useBrandLanguage } from './BrandLanguage';
import ConnectedBrains from './ConnectedBrains';

/** A brand illustration, not a visualization of a running model. */
export default function BrandHero() {
  const { language } = useBrandLanguage();
  const ko = language === 'ko';
  return <section className="cb-hero cx-wrap" aria-labelledby="brand-statement">
    <div className="cb-hero-intro">
      <p className="cb-overline"><span className="cb-live-dot" /> THE AI BRAIN FOR COMPANY DECISIONS.</p>
      <h1 id="brand-statement" lang="en"><span>Independent<br />brains.</span><span>Connected<br />intelligence.</span></h1>
    </div>
    <ConnectedBrains />
    <div className="cb-hero-summary">
      <p>{ko ? <>기업의 의사결정을 위한 인공지능 두뇌.<br />우리가 소유하고, 함께 연결합니다.</> : <>Building AI we can own, run, and connect—<br />on our own terms.</>}</p>
      <div className="cb-hero-actions"><a className="cb-button" href="#evolution">{ko ? '프로젝트 둘러보기' : 'Explore the projects'}<ArrowDown size={18} /></a><Link className="cb-text-link" to="/models">{ko ? '의사결정 AI, C1' : 'Meet C1'}<ArrowUpRight size={18} /></Link></div>
    </div>
    <div className="cb-hero-foot"><span>OWN. RUN. CONNECT.</span><span>CONNECT AI / C1</span><a href="#decisions">{ko ? '두뇌의 역할' : 'The decision layer'}<ArrowDown size={15} /></a></div>
  </section>;
}
